import { FunctionComponent } from 'react';
import Message, { MessageProps } from './Message';

const ErrorMessage: FunctionComponent<MessageProps> = props => <Message className="message-error" {...props} />;

export default ErrorMessage;
